import capitalize from 'lodash/capitalize'

export default {
  
  methods: {
    updatePts(name) {
      if (this.param[name].value && !this.param[name].score) {
        this.param[name].score = 1
      }
    },
    
    validateValue(rule, value, callback) {
      if (this.param[rule.param].score > 0 && !value) {
        callback(new Error(`${capitalize(rule.param)} is required`))
      } else {
        callback()
      }
    },

    validateScore(rule, value, callback) {
      if (this.param[rule.param].value && value <= 0) {
        callback(new Error('Score is required'))
      } else {
        callback()
      }
    },

    validateAll() {
      let isValid = false
      this.$refs['form-criteria'].validate(valid => {
        isValid = valid
      })
      return isValid
    },
  },
}
  